/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2024] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 02/Aug/2024.
 */

package com.narbase.letsgo.common

import com.narbase.letsgo.deployment.Environment
import com.narbase.letsgo.web.routing.domain.appSettings.Platform.*
import kotlinx.browser.window
import org.w3c.dom.get


actual val isMobile: Boolean
    get() =
        if (isMobileDev) true
        else when (platform) {
            iOS, Android -> true
            Web -> false
        }

actual val commonEnvironment: Environment
    get() = if (isDev) Environment.Dev
    else if (isStaging) Environment.Staging
    else Environment.Prod

actual val mobileServerUrl: String?
    get() {
        return window.localStorage[MOBILE_SERVER_URL_KEY]?.ifBlank { null } 
    }
